import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {FinancementInfo} from '../../../interface/api/FinancementInfo';
import {HydraService} from '../../../core/services/hydra.service';
import {FinancementAideType} from '../../../interface/api/FinancementAideType';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {api} from '../../../api/api-dictionnary';
import {TranslationService} from '../../services/translation.service';
import {ToolsService} from '../../services/tools/tools.service';

import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { DateMonthComponent } from '../date-month/date-month.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-financement',
    template: `
        <h4 mat-dialog-title>{{ title|translate }}</h4>
        @if (financement !== null) {
          <mat-dialog-content>
            <!--Nom + Titre-->
            <div class="row">
              @if (config['nomPorteur']) {
                <div class="col-3">
                  <label for="nomPorteur"
                    >{{'general.nomPorteur'|translate}} : <span class="star">*</span></label
                    >
                    <input
                      class="form-control"
                      type="text"
                      name="nomPorteur"
                      required
                      id="nomPorteur"
                      [(ngModel)]="financement.nomPorteur"
                      />
                    </div>
                  }
                  @if (config['titreProjet']) {
                    <div class="col">
                      <label for="titreProjet">{{'general.titreProjet'|translate}} :</label>
                      <input
                        class="form-control"
                        type="text"
                        name="titreProjet"
                        id="titreProjet"
                        [(ngModel)]="financement.titreProjet"
                        />
                      </div>
                    }
                    @if (config['organisme']) {
                      <div class="col">
                        <label for="organisme"
                          >{{'general.organisme'|translate}} : <span class="star">*</span></label
                          >
                          <input
                            class="form-control"
                            type="text"
                            name="organisme"
                            required
                            id="organisme"
                            [(ngModel)]="financement.organisme"
                            />
                          </div>
                        }
                      </div>
                      <!--Montant-->
                      <div class="row mt-1">
                        @if (config['montantDemande']) {
                          <div class="col">
                            <label for="MontantDemande"
                              >{{'general.montantDemande'|translate}} : <span class="star">*</span></label
                              >
                              <input
                                class="form-control"
                                type="number"
                                min="0"
                                id="MontantDemande"
                                required
                                name="MontantDemande"
                                [(ngModel)]="financement.montantDemande"
                                />
                              </div>
                            }
                            @if (config['montantAccorde']) {
                              <div class="col">
                                <label for="Montant"
                                  >{{'general.montantAccorde'|translate}} : <span class="star">*</span></label
                                  >
                                  <input
                                    class="form-control"
                                    type="number"
                                    min="0"
                                    id="Montant"
                                    required
                                    name="Montant"
                                    [(ngModel)]="financement.montantAccorde"
                                    />
                                  </div>
                                }
                              </div>
                              <!--Montant et Période-->
                              <div class="row mt-1">
                                @if (config['periodSoutient']) {
                                  <div class="col">
                                    <label for="periodDebut"
                                      >{{'general.debutSoutien'|translate}} : <span class="star">*</span></label
                                      >
                                      <app-date-month
                                        id="periodDebut"
                                        [value]="financement.dateDebutSoutien"
                                        (dateChange)="financement.dateDebutSoutien = dateSansTimezone($event)"
                                      ></app-date-month>
                                      <!--<input
                                      class="form-control"
                                      type="month"
                                      id="periodDebut"
                                      required
                                      name="periodDebut"
                                      [(ngModel)]="financement.dateDebutSoutien"
                                      />-->
                                    </div>
                                  }
                                  @if (config['periodSoutient']) {
                                    <div class="col">
                                      <label for="periodFin"
                                        >{{'general.finSoutien'|translate}} : <span class="star">*</span></label
                                        >
                                        <app-date-month
                                          id="periodFin"
                                          [value]="financement.dateFinSoutien"
                                          (dateChange)="financement.dateFinSoutien = dateSansTimezone($event)"
                                        ></app-date-month>
                                        <!--<input
                                        class="form-control"
                                        type="month"
                                        id="periodFin"
                                        required
                                        name="periodFin"
                                        [(ngModel)]="financement.dateFinSoutien"
                                        />-->
                                      </div>
                                    }
                                  </div>
                                  <!--AidesTypes-->
                                  <div class="row mt-1">
                                    @if (config['typeAide']) {
                                      <div class="col">
                                        <label for="aideType"
                                          >{{'general.typeAide'|translate}} : <span class="star">*</span></label
                                          >
                                          <mat-select
                                            [disabled]="config['organisme']"
                                            class="form-control"
                                            id="aideType"
                                            name="aideType"
                                            [compareWith]="compareWithTypeAide"
                                            [(ngModel)]="financement.typeAide"
                                            >
                                            @for (type of aideTypes; track type) {
                                              <mat-option
                                                [value]="type"
                                                >{{ getAideTypeLabel(type) }}
                                                </mat-option
                                                >
                                            }
                                          </mat-select>
                                        </div>
                                      }
                                      @if (
                                        financement.typeAide !== null && financement.typeAide !== undefined
                                        && financement.typeAide['code'] === 'Others'
                                        ) {
                                        <div
                                          class="col"
                                          >
                                          <label for="aideTypeCustom"
                                            >{{'general.saisirTypeAide'|translate}} :
                                            <span class="star">*</span></label
                                            >
                                            <input
                                              class="form-control"
                                              required
                                              type="text"
                                              id="aideTypeCustom"
                                              name="aideTypeCustom"
                                              [(ngModel)]="financement.typeAideAutre"
                                              />
                                            </div>
                                          }
                                        </div>
                                        <!--Année demande et réponse -->
                                        <div class="row mt-1">
                                          @if (config['dateDemande']) {
                                            <div class="col">
                                              <label for="anneeDemande"
                                                >{{'general.anneeDemande'|translate}} :
                                                <span class="star">*</span></label
                                                >
                                                <input
                                                  class="form-control"
                                                  required
                                                  type="number"
                                                  min="1900"
                                                  max="2100"
                                                  id="anneeDemande"
                                                  name="anneeDemande"
                                                  [(ngModel)]="dateDemande"
                                                  (keyup)="valideAnnee($event)"
                                                  />
                                                </div>
                                              }
                                              @if (config['dateResponse']) {
                                                <div class="col">
                                                  <label for="responseDemande"
                                                    >{{'fields.formFieldFinancementDossier.dateReponse'|translate}} : <span class="star">*</span></label
                                                    >
                                                    <app-date-month
                                                      id="responseDemande"
                                                      [value]="financement.dateReponse"
                                                      (dateChange)="financement.dateReponse = $event.toISOString()"
                                                    ></app-date-month>
                                                    <!--                    <input
                                                    class="form-control"
                                                    required
                                                    type="month"
                                                    id="anneDemande"
                                                    name="anneDemande"
                                                    [(ngModel)]="financement.dateReponse"
                                                    />-->
                                                  </div>
                                                }
                                              </div>
                                              <br/>
                                              <p class="t-a-r">
                                                {{'general.champsMarquesEtoile'|translate}}
                                                <span class="star">*</span> {{'general.sontObligatoires'|translate}}.
                                              </p>
                                            </mat-dialog-content>
                                          }
                                          <mat-dialog-actions>
                                            <button mat-button [mat-dialog-close]="false">{{'general.annuler'|translate}}</button>
                                            <button
                                              mat-raised-button
                                              color="primary"
                                              [disabled]="!formValid()"
                                              (click)="add()"
                                              >
                                              {{'general.ajouter'|translate}}
                                            </button>
                                          </mat-dialog-actions>
        `,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, DateMonthComponent, MatSelect, MatOption, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class ModalFinancementComponent implements OnInit {
    dialogRef = inject<MatDialogRef<ModalFinancementComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);
    private hydraService = inject(HydraService);
    translationService = inject(TranslationService);
    toolService = inject(ToolsService);

    public title = 'Ajouter un nouveau financement.';
    public config = null;
    public financement: FinancementInfo = null;
    public aideTypes: FinancementAideType[] = [];
    private timer = null;
    public dateDemande: number;

    constructor() {
        const data = this.data;

        this.config = data.config;
        this.financement = data.financementInfo;
        this.getFinancementAideTypes();
        if (data.title) {
            this.title = data.title;
        }
    }

    public getFinancementAideTypes() {
        this.hydraService
            .getList(api.financementAideTypes, true)
            .subscribe((res: HydraCollection) => {
                this.aideTypes = res.getMember();
                if (this.config['organisme']) {
                    this.financement.typeAide = this.aideTypes[
                    this.aideTypes.length - 1
                        ];
                }
            });
    }

    public getAideTypeLabel(type: FinancementAideType) {
        return this.translationService.getTranslation(type)?.label;
    }

    public add() {
        delete this.financement.position;
        this.dialogRef.close(this.financement);
    }

    public formValid(): boolean {
        let valid = true;
        if (this.config['nomPorteur']) {
            if (
                this.financement.nomPorteur == null ||
                !this.financement.nomPorteur.length
            )
                {valid = false;}
        }
        if (this.config['organisme']) {
            if (
                this.financement.organisme == null ||
                !this.financement.organisme.length
            )
                {valid = false;}
        }
        if (this.config['typeAide']) {
            if (this.financement.typeAide == null) {valid = false;}
            if (
                this.financement.typeAide != null &&
                this.financement.typeAide['code'] == 'Others'
            ) {
                if (
                    this.financement.typeAideAutre == null ||
                    !this.financement.typeAideAutre.trim().length
                )
                    {valid = false;}
            }
        } else {
            if (this.financement.typeAideAutre == null ||
                !this.financement.typeAideAutre.trim().length
            )
                {valid = false;}
        }

        if (this.config['montantDemande']) {
            if (
                this.financement.montantDemande == null ||
                !this.financement.montantDemande
            )
                {valid = false;}
        }
        if (this.config['montantAccorde']) {
            if (
                this.financement.montantAccorde == null ||
                !this.financement.montantAccorde
            )
                {valid = false;}
        }
        if (this.config['periodSoutient']) {
            if (!this.financement.dateDebutSoutien) {valid = false;}
        }
        if (this.config['periodSoutient']) {
            if (!this.financement.dateFinSoutien) {valid = false;}
        }
        if (this.config['dateDemande']) {
            if ( this.dateDemande == null || this.dateDemande < 1900 || this.dateDemande > 2100) {
                valid = false;
            } else {
                this.financement.dateDemande = this.dateDemande + '';
            }


        }
        if (this.config['dateResponse']) {
            if (!this.financement.dateReponse) {valid = false;}
        }

        return valid;
    }

    ngOnInit() {
        if(this.financement.dateDemande == null) {
            const currentDate = new Date();
            this.dateDemande = currentDate.getFullYear();
        } else {
            this.dateDemande = +this.financement.dateDemande;
        }
    }

    valideAnnee(event){
        clearTimeout(this.timer);
        const annee = event.target.value;
        this.timer = setTimeout(() => {
            if(annee < 1900) {
                this.dateDemande = 1900;
            } else if (annee > 2100) {
                this.dateDemande = 2100;
            }
        }, 1500);

    }

    compareWithTypeAide(elem1, elem2) {
        if(elem1 != null && elem2 != null) {
            return elem1.id == elem2.id;
        }
    }

    dateSansTimezone(date) {
        const newDate = date.getFullYear() + '-' +
            this.toolService.convertDate10((date.getMonth()+1)) + '-' +
            this.toolService.convertDate10(date.getDate()) + ' ' +
            this.toolService.convertDate10(date.getHours()) + ':' +
            this.toolService.convertDate10(date.getMinutes()) + ':' +
            this.toolService.convertDate10(date.getSeconds());
        //console.log(newDate, date);

        return newDate;
    }
}
